import {ConfEnv} from "@/config/config";
import privateRequest from "@/Infra/http/private.request";
import publicRequest from "@/Infra/http/public.request";

const getMyReferralLinkService = async () => {
  const response = await privateRequest.get(`${ConfEnv.API_REFERRAL.MY_REFERRAL_LINK}`);
  return response;
};

const getMyReferralsStatsService = async () => {
  const response = await privateRequest.get(`${ConfEnv.API_REFERRAL.MY_REFERRALS_STATS}`);
  return response;
};

const getMyReferralsService = async () => {
  const response = await privateRequest.get(`${ConfEnv.API_REFERRAL.MY_REFERRALS}`);
  return response;
};

const postReferralCodeService = async data => {
  const response = await privateRequest.post(`${ConfEnv.API_REFERRAL.REFERRAL_CODE}`, data);
  return response;
};

const getTopReferralsService = async () => {
  const response = await publicRequest.get(`${ConfEnv.API_URL.TOP_REFERRALS}`);
  return response;
};

export {
  getMyReferralLinkService,
  getMyReferralsStatsService,
  getMyReferralsService,
  postReferralCodeService,
  getTopReferralsService,
};
